<template>
  <h3 class="ui dividing header">
    <i :class="[data.icon,'icon']"/>
    <div class="content">
      {{ $tc(data.header) }}
      <div class="sub header">
        {{ $tc(data.subheader) }}
      </div>
    </div>
  </h3>
</template>

<script>
export default {
  name: 'InputHeader',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/*
h3:first-child {
  margin: calc(2rem - .14285714em) 0 1rem !important;
}
*/
</style>
